import { BreadCrumbs, getBreadCrumbLinks } from '../BreadCrumbs';
import type { PublicPageCoCoProps } from './types';

export const PublicPageCoCo = (props: PublicPageCoCoProps) => {
  return (
    <div className="page site cms-page of-public-page" data-page-id={props.pageId}>
      <BreadCrumbs breadCrumbPaths={getBreadCrumbLinks(props.breadcrumbs, props.siteStructureNodes)} />
      {props.children}
    </div>
  );
};
